import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import ModuleAccessManagement from '../../components/ModuleAccessManagement';
import { docConvertAPI } from '../../api/docConvertApi';

const DocConvertAccessPage = () => (
  <ModuleAccessManagement
    title="Word → Excel Erişimi"
    description="Bu modülü görebilecek ve kullanabilecek kullanıcıları seçin."
    api={docConvertAPI}
    accent="orange"
    icon={ShieldCheckIcon}
  />
);

export default DocConvertAccessPage;
